

















import { Component, Prop } from "vue-property-decorator";
import UserBlock from "@share/common/user/UserBlock.vue";
import UserInfoPopup from "@share/common/user-info-popup/UserInfoPopup.vue";
import UsersListItemBase from "@share/common/users-list/UsersListItemBase";

@Component({
    components: { UserBlock, UserInfoPopup }
})
export default class SlotUserProfile extends UsersListItemBase {
    @Prop({required: true}) profile: any;
}
